var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Action, Selector, State, Store } from '@ngxs/store';
import { FoldersApiService } from '../folders/api/folders-api.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { DriveEntryApiService } from '../drive-entry-api.service';
import { Router } from '@angular/router';
import { DriveUrlsService } from '../drive-urls.service';
import { RouterState } from '@ngxs/router-plugin';
import isEqual from 'lodash/isEqual';
import { AddEntries, BuildFolderTree, DeleteSelectedEntries, DeleteTrashedEntriesForever, DeselectAllEntries, EmptyTrash, LoadUserFolders, MoveEntries, OpenConfirmDialog, OpenFolder, OpenUploadsPanel, RestoreTrashedEntries, SelectEntries, ToggleDetailsSidebar, SetViewMode, UploadFiles, OpenFilePreview, AddStar, RemoveStar, RemoveEntries, OpenSearchPage, LoadMoreEntries, ReloadPageEntries, ToggleSidebar, CopySelectedEntries, OpenUploadWindow, LoadUserSpaceUsage, ShowLoadingToast, HideLoadingToast, ResetState, UpdateEntries, SelectAllEntries, SetCurrentUser, UpdateEntryDescription, } from './actions/commands';
import { EntryRenamed, EntryContextMenuOpened, FileDeleteSuccess, EntryDoubleTapped, EntrySelectedViaContextMenu, EntriesSelectedViaDrag, EntryTapped, FolderPageOpened, MoveEntriesFailed, MoveEntriesSuccess, NewFolderCreated, RecentEntriesPageOpened, SearchPageOpened, SharesFolderOpened, StarredPageOpened, StartedDragging, StoppedDragging, TrashedEntriesDeleteSuccess, TrashedEntriesRestoreSuccess, TrashPageOpened, UserSpaceUsageChanged, NotEnoughSpaceError, BreakpointChanged } from './actions/events';
import { VIEW_MODE_KEY } from './models/drive-state-model';
import { DRIVE_STATE_MODEL_DEFAULTS } from './models/drive-state-model-defaults';
import { LocalStorage } from 'common/core/services/local-storage.service';
import { ROOT_FOLDER } from '../folders/root-folder';
import { UploadQueueService } from 'common/uploads/upload-queue/upload-queue.service';
import { DriveUploadValidator } from '../uploads/drive-upload-validator';
import { openUploadWindow } from 'common/uploads/utils/open-upload-window';
import { LoadingToastMessages } from '../messages/loading-toast/loading-toast-messages';
import { User } from 'common/core/types/models/User';
import { DrivePage, TRASH_PAGE } from './models/drive-page';
import { EMPTY } from 'rxjs';
var DriveState = /** @class */ (function () {
    function DriveState(foldersApi, entriesApi, router, driveUrls, uploads, store, localStore, validator, uploadInputConfig) {
        this.foldersApi = foldersApi;
        this.entriesApi = entriesApi;
        this.router = router;
        this.driveUrls = driveUrls;
        this.uploads = uploads;
        this.store = store;
        this.localStore = localStore;
        this.validator = validator;
        this.uploadInputConfig = uploadInputConfig;
    }
    DriveState_1 = DriveState;
    DriveState.flatFolders = function (state) {
        return state.flatFolders;
    };
    DriveState.userFoldersLoaded = function (state) {
        return state.userFoldersLoaded;
    };
    DriveState.activePage = function (state) {
        return state.activePage;
    };
    DriveState.activePageName = function (state) {
        return state.activePage.name;
    };
    DriveState.userFolders = function (state) {
        return state.folderTree;
    };
    DriveState.selectedEntries = function (state) {
        return state.selectedEntries;
    };
    DriveState.selectedEntryIds = function (state, selectedEntries) {
        return selectedEntries.map(function (entry) { return entry.id; });
    };
    DriveState.selectedEntry = function (state, selected) {
        return selected ? selected[selected.length - 1] : null;
    };
    DriveState.selectedEntryOrActiveFolder = function (state, selected) {
        return selected || state.activePage.folder;
    };
    DriveState.selectedEntryParent = function (state, selected, folders) {
        if (!selected || !folders || !selected.parent_id)
            return ROOT_FOLDER;
        return folders[selected.parent_id];
    };
    DriveState.anythingSelected = function (state, selectedEntries) {
        return selectedEntries.length > 0;
    };
    DriveState.allSelectedEntriesStarred = function (state, selectedEntries) {
        return selectedEntries.every(function (entry) { return !!entry.tags.find(function (tag) { return tag.name === 'starred'; }); });
    };
    DriveState.onlyFoldersSelected = function (state, selectedEntries) {
        return selectedEntries.every(function (entry) { return entry.type === 'folder'; });
    };
    DriveState.entries = function (state) {
        return state.entries;
    };
    DriveState.entriesEmpty = function (state) {
        // only return true if entries have already loaded
        return state.meta.currentPage && !state.loading && state.entries.length === 0;
    };
    DriveState.multipleEntriesSelected = function (state, selectedEntries) {
        return selectedEntries.length > 1;
    };
    DriveState.activeFolder = function (state) {
        return state.activePage.folder;
    };
    DriveState.selectedFolderId = function (state, selectedEntries) {
        var folder = selectedEntries.filter(function (entry) { return entry.type === 'folder'; })[0];
        return folder ? folder.id : null;
    };
    DriveState.meta = function (state) {
        return state.meta;
    };
    DriveState.dragging = function (state) {
        return state.dragging;
    };
    DriveState.loading = function (state) {
        return state.loading;
    };
    DriveState.currentPage = function (state) {
        return state.meta.currentPage;
    };
    DriveState.viewMode = function (state) {
        return state.viewMode;
    };
    DriveState.detailsOpen = function (state) {
        return state.detailsVisible;
    };
    DriveState.sidebarOpen = function (state) {
        return state.sidebarOpen;
    };
    DriveState.sortColumn = function (state) {
        return state.meta.sortColumn;
    };
    DriveState.sortDirection = function (state) {
        return state.meta.sortDirection;
    };
    DriveState.canLoadMoreEntries = function (state) {
        return state.meta.currentPage < state.meta.lastPage;
    };
    DriveState.userSpaceUsed = function (state) {
        return state.spaceUsage.used;
    };
    DriveState.userSpaceAvailable = function (state) {
        return state.spaceUsage.available;
    };
    DriveState.spaceUsedPercent = function (state, spaceUsed, spaceAvail) {
        return (spaceUsed * 100) / spaceAvail;
    };
    DriveState.isMobile = function (state) {
        return state.isMobile;
    };
    DriveState.userHasPermission = function (permission, folder, user) {
        // we are not in a folder view, can bail
        if (!folder || !user)
            return false;
        if (folder.id === 'root')
            return true;
        // check if user is the owner of currently open folder
        var folderUser = folder.users.find(function (u) { return u.id === user.id; });
        if (folderUser.owns_entry)
            return true;
        return folderUser.entry_permissions[permission];
    };
    DriveState.currentUser = function (state) {
        return state.currentUser;
    };
    DriveState.userOwnsActiveFolder = function (state, activeFolder, currentUser) {
        return DriveState_1.userHasPermission('owner', activeFolder, currentUser);
    };
    DriveState.userCanEditSelectedFolder = function (state, activeFolder, currentUser) {
        return DriveState_1.userHasPermission('edit', activeFolder, currentUser);
    };
    DriveState.userCanEditSelectedEntries = function (state, entries, currentUser) {
        return entries.every(function (entry) {
            var user = entry.users.find(function (u) { return u.id === currentUser.id; });
            return user && (user.owns_entry || user.entry_permissions.edit);
        });
    };
    DriveState.canUpload = function (state, page, userCanEditFolder) {
        return page.folder && userCanEditFolder;
    };
    DriveState.prototype.loadUserFolders = function (ctx) {
        return this.foldersApi.getAllForCurrentUser().pipe(tap(function (response) {
            return ctx.dispatch(new BuildFolderTree(response.folders));
        }));
    };
    DriveState.prototype.buildFolderTree = function (ctx, action) {
        var hashTable = {};
        var tree = [];
        if (action.folders) {
            for (var i = 0, len = action.folders.length; i < len; i++) {
                var folder = action.folders[i];
                hashTable[folder.id] = folder;
            }
        }
        else {
            hashTable = ctx.getState().flatFolders;
        }
        for (var id in hashTable) {
            if (!hashTable.hasOwnProperty(id))
                continue;
            var folder = hashTable[id];
            // clear children from previous builds, to prevent duplicates
            folder.children = [];
            if (folder.parent_id) {
                var parent_1 = hashTable[folder.parent_id];
                if (parent_1) {
                    if (!parent_1.children)
                        parent_1.children = [];
                    parent_1.children.push(folder);
                }
            }
            else {
                tree.push(folder);
            }
        }
        ctx.patchState({
            folderTree: tree,
            flatFolders: hashTable,
            userFoldersLoaded: true,
        });
    };
    DriveState.prototype.loadDriveEntries = function (ctx, action) {
        var oldState = ctx.getState(), newState = { loading: true, meta: __assign({}, oldState.meta) };
        // only replace active page if it's actually specified, this way
        // "Reload" and "LoadMore" actions will not remove active page
        newState.activePage = action.page ? action.page : oldState.activePage;
        // set sorting from specified query params or specified page or currently active page
        newState.meta.sortColumn = action.queryParams.orderBy || oldState.meta.sortColumn || newState.activePage.sortColumn;
        newState.meta.sortDirection = action.queryParams.orderDir || oldState.meta.sortDirection || newState.activePage.sortDirection;
        // if it's not search page, clear type and query
        if (newState.activePage.name !== 'search') {
            newState.meta.query = null;
            newState.meta.type = null;
        }
        newState.meta.query = action.queryParams.query || newState.meta.query;
        newState.meta.type = action.queryParams.type || newState.meta.type;
        ctx.patchState(newState);
        var params = this.transformQueryParams(__assign({}, action.queryParams, newState.activePage.queryParams));
        return this.entriesApi.getEntriesForFolder(params).pipe(tap(function (response) {
            var entries = action.loadMore ? oldState.entries : [];
            var state = {
                entries: entries.concat(response.data),
                meta: __assign({}, newState.meta, { lastPage: response.last_page, currentPage: response.current_page }),
                loading: false
            };
            // make sure "root" page folder is not overridden, it's
            // a static constant, so is not returned from backend
            if (newState.activePage.name !== 'root') {
                state.activePage = __assign({}, newState.activePage, { folder: response.folder });
            }
            return ctx.patchState(state);
        }, function () {
            return ctx.patchState({ loading: false });
        }));
    };
    DriveState.prototype.openFolder = function (ctx, action) {
        var currentFolder = ctx.getState().activePage.folder;
        if (currentFolder && action.folder.id === currentFolder.id)
            return;
        if (action.folder && action.folder['deleted_at']) {
            return ctx.dispatch(new OpenConfirmDialog({
                title: 'Folder is in trash',
                body: 'To view this folder, you need to restore it first.',
                ok: 'Restore'
            }, new RestoreTrashedEntries()));
        }
        else {
            ctx.patchState({ loading: true });
            return this.router.navigate([this.driveUrls.folder(action.folder)]);
        }
    };
    DriveState.prototype.openSearchPage = function (ctx, action) {
        var oldParams = this.store.selectSnapshot(RouterState.state).root.queryParams;
        if (isEqual(oldParams, action.queryParams))
            return;
        ctx.patchState({ loading: true });
        return this.router.navigate(['/drive/search'], { queryParams: action.queryParams });
    };
    DriveState.prototype.selectEntries = function (ctx, action) {
        ctx.patchState({ selectedEntries: action.entries });
    };
    DriveState.prototype.deselectAllEntries = function (ctx) {
        if (!ctx.getState().selectedEntries.length)
            return;
        ctx.patchState({ selectedEntries: [] });
    };
    DriveState.prototype.SelectAllEntries = function (ctx) {
        ctx.patchState({ selectedEntries: ctx.getState().entries.slice() });
    };
    DriveState.prototype.entryTapped = function (ctx, action) {
        var current = ctx.getState().selectedEntries.slice();
        var alreadySelected = false;
        // remove entry with matching ID (if exists) to avoid duplicates
        var i = current.findIndex(function (curr) { return curr.id === action.entry.id; });
        if (i > -1) {
            current.splice(i, 1);
            alreadySelected = true;
        }
        if (action.ctrlKey) {
            if (alreadySelected) {
                ctx.patchState({ selectedEntries: current });
            }
            else {
                ctx.patchState({ selectedEntries: current.concat([action.entry]) });
            }
        }
        else {
            ctx.patchState({ selectedEntries: [action.entry] });
        }
    };
    DriveState.prototype.entryDoubleTapped = function (ctx, action) {
        if (action.entry.type === 'folder') {
            return ctx.dispatch(new OpenFolder(action.entry));
        }
        else {
            return ctx.dispatch(new OpenFilePreview([action.entry]));
        }
    };
    DriveState.prototype.deleteSelectedEntries = function (ctx) {
        var _this = this;
        var entries = this.store.selectSnapshot(DriveState_1.selectedEntries), entryIds = this.store.selectSnapshot(DriveState_1.selectedEntryIds), flatFolders = this.store.selectSnapshot(DriveState_1.flatFolders), activePage = ctx.getState().activePage;
        return this.entriesApi.delete({ entryIds: entryIds }).pipe(tap(function () {
            // filter out deleted entries
            var newEntries = ctx.getState().entries
                .filter(function (entry) { return entryIds.indexOf(entry.id) === -1; });
            var newState = { entries: newEntries }, actions = [new FileDeleteSuccess(entries)];
            // clear selected entries
            newState.selectedEntries = [];
            // if selected folder was active, navigate to its parent
            if (activePage.folder && entryIds.indexOf(activePage.folder.id) > -1) {
                _this.store.dispatch(new OpenFolder(_this.store.selectSnapshot(DriveState_1.selectedEntryParent)));
            }
            // rebuild folders tree
            var folders = entries.filter(function (entry) { return entry.type === 'folder'; });
            if (folders.length) {
                folders.forEach(function (folder) { return delete flatFolders[folder.id]; });
                newState.flatFolders = flatFolders;
                actions.push(new BuildFolderTree());
            }
            ctx.patchState(newState);
            return ctx.dispatch(actions);
        }));
    };
    DriveState.prototype.fileContextMenuOpened = function (ctx, action) {
        if (!action.entry)
            return;
        var fileAlreadySelected = ctx.getState().selectedEntries
            .find(function (entry) { return entry.id === action.entry.id; });
        if (!fileAlreadySelected) {
            return ctx.dispatch(new EntrySelectedViaContextMenu([action.entry]));
        }
    };
    DriveState.prototype.newFolderCreated = function (ctx, action) {
        var _a;
        var state = ctx.getState(), newFolderId = action.folder.parent_id || 'root';
        // start new folder into user folders cache
        var newState = {
            flatFolders: __assign({}, state.flatFolders, (_a = {}, _a[action.folder.id] = action.folder, _a))
        };
        // push new folder into parent folder entries, if parent is currently open
        if (newFolderId === state.activePage.folder.id) {
            newState.entries = [action.folder].concat(state.entries);
        }
        ctx.patchState(newState);
        // rebuild folder tree
        return ctx.dispatch(new BuildFolderTree());
    };
    DriveState.prototype.entryRenamed = function (ctx, action) {
        var state = ctx.getState(), newState = { entries: state.entries.slice() }, i = newState.entries.findIndex(function (curr) { return curr.id === action.entry.id; });
        // rename entry inside main entries array
        if (i > -1) {
            newState.entries[i] = __assign({}, newState.entries[i], { name: action.newName });
        }
        // rename entry inside selected entries array
        newState.selectedEntries = [__assign({}, state.selectedEntries[0], { name: action.newName })];
        // rename active folder
        if (state.activePage.folder && state.activePage.folder.id === action.entry.id) {
            newState.activePage = __assign({}, state.activePage, { folder: action.entry });
        }
        // rebuild folder tree
        if (action.entry.type === 'folder') {
            var flatFolders = __assign({}, state.flatFolders);
            flatFolders[action.entry.id] = __assign({}, flatFolders[action.entry.id], { name: action.newName });
            newState.flatFolders = flatFolders;
            ctx.dispatch(new BuildFolderTree());
        }
        ctx.patchState(newState);
    };
    DriveState.prototype.startedDragging = function (ctx) {
        ctx.patchState({ dragging: true });
    };
    DriveState.prototype.stoppedDragging = function (ctx) {
        ctx.patchState({ dragging: false });
    };
    DriveState.prototype.movieEntries = function (ctx, action) {
        var entries = action.entries || ctx.getState().selectedEntries;
        if (!DriveState_1.canMoveEntriesTo(entries, action.destination))
            return;
        ctx.dispatch(new ShowLoadingToast(LoadingToastMessages.moveEntries));
        var minimal = entries.map(function (entry) {
            return { id: entry.id, type: entry.type === 'folder' ? 'folder' : 'file' };
        });
        var oldLocation = entries[0].parent_id;
        return this.entriesApi.moveEntries({ entries: minimal, destination: action.destination.id }).pipe(finalize(function () { return ctx.dispatch(new HideLoadingToast()); }), tap(function (response) {
            return ctx.dispatch(new MoveEntriesSuccess(action.destination.id, oldLocation, response.entries));
        }, function (error) {
            return ctx.dispatch(new MoveEntriesFailed(error.messages));
        }));
    };
    DriveState.prototype.moveEntriesSuccess = function (ctx, action) {
        var state = ctx.getState(), entryIds = action.entries.map(function (entry) { return entry.id; }), folders = action.entries.filter(function (entry) { return entry.type === 'folder'; });
        // remove moved entries from old folder
        var newState = {
            selectedEntries: [],
            entries: state.entries.filter(function (entry) { return entryIds.indexOf(entry.id) === -1; })
        };
        // rebuild folder tree
        if (folders.length) {
            newState.flatFolders = __assign({}, state.flatFolders);
            action.entries
                .filter(function (entry) { return entry.type === 'folder'; })
                .forEach(function (entry) { return newState.flatFolders[entry.id] = entry; });
        }
        // update active folder
        if (state.activePage.folder) {
            var folder = action.entries.find(function (entry) { return state.activePage.folder.id === entry.id; });
            if (folder)
                newState.activePage = __assign({}, state.activePage, { folder: folder });
        }
        ctx.patchState(newState);
        return ctx.dispatch(new BuildFolderTree());
    };
    DriveState.prototype.toggleViewMode = function (ctx, action) {
        var current = ctx.getState().viewMode, viewMode = action.mode || current === 'list' ? 'grid' : 'list';
        this.localStore.set(VIEW_MODE_KEY, viewMode);
        ctx.patchState({ viewMode: viewMode });
    };
    DriveState.prototype.toggleDetailsSidebar = function (ctx) {
        ctx.patchState({
            detailsVisible: !ctx.getState().detailsVisible
        });
    };
    DriveState.prototype.toggleSidebar = function (ctx) {
        ctx.patchState({
            sidebarOpen: !ctx.getState().sidebarOpen
        });
    };
    DriveState.prototype.addEntries = function (ctx, action) {
        var currentEntries = ctx.getState().entries, spaceUsage = ctx.getState().spaceUsage;
        var newEntries = action.entries
            .filter(function (entry) { return !currentEntries.find(function (curr) { return curr.id === entry.id; }); });
        var newSize = newEntries.filter(function (entry) { return entry.type !== 'folder'; })
            .reduce(function (sum, entry) { return sum + entry.file_size; }, 0);
        ctx.patchState({
            entries: newEntries.concat(currentEntries),
            spaceUsage: __assign({}, spaceUsage, { used: spaceUsage.used + newSize })
        });
    };
    DriveState.prototype.uploadFiles = function (ctx, action) {
        if (!this.enoughSpaceLeftToUpload(ctx.getState().spaceUsage, action.files)) {
            return ctx.dispatch(new NotEnoughSpaceError());
        }
        if (!action.files.length)
            return;
        ctx.dispatch(new OpenUploadsPanel());
        var state = ctx.getState(), folder = state.activePage.folder, parentId = (folder && folder !== ROOT_FOLDER) ? folder.id : null;
        var config = {
            httpParams: { parentId: parentId },
            validator: this.validator,
        };
        return this.uploads.start(action.files, config).pipe(catchError(function () { return EMPTY; }), tap(function (entry) {
            // get parent folders, if user has uploaded folders and not single files
            var entries = [entry.parent, entry];
            // remove all entries that are not direct child of currently open folder
            var newEntries = entries
                .filter(function (newEntry) { return newEntry && newEntry.parent_id === parentId; });
            // add newly uploaded files and created folders
            ctx.dispatch(new AddEntries(newEntries));
            // rebuild folder tree, if there are any folders
            var folders = entries.filter(function (entry) { return entry && entry.type === 'folder'; });
            if (folders.length) {
                var flatFolders_1 = __assign({}, ctx.getState().flatFolders);
                folders.forEach(function (f) { return flatFolders_1[f.id] = f; });
                ctx.patchState({ flatFolders: flatFolders_1 });
                ctx.dispatch(new BuildFolderTree());
            }
        }));
    };
    DriveState.prototype.deleteTrashedEntriesForever = function (ctx) {
        var selectedEntries = this.store.selectSnapshot(DriveState_1.selectedEntries), entryIds = selectedEntries.map(function (entry) { return entry.id; });
        var newEntries = ctx.getState().entries
            .filter(function (entry) { return entryIds.indexOf(entry.id) === -1; });
        return this.entriesApi.delete({ entryIds: entryIds, deleteForever: true }).pipe(tap(function () {
            ctx.patchState({
                entries: newEntries,
                selectedEntries: [],
            });
            return ctx.dispatch([
                new TrashedEntriesDeleteSuccess(selectedEntries),
                new UserSpaceUsageChanged(),
            ]);
        }));
    };
    DriveState.prototype.restoreTrashedEntries = function (ctx, action) {
        var activePage = this.store.selectSnapshot(DriveState_1.activePage);
        var restoredEntries = action.entries || this.store.selectSnapshot(DriveState_1.selectedEntries);
        var entryIds = restoredEntries.map(function (entry) { return entry.id; });
        var newEntries;
        if (activePage.name === TRASH_PAGE.name) {
            newEntries = ctx.getState().entries
                .filter(function (entry) { return entryIds.indexOf(entry.id) === -1; });
        }
        else {
            newEntries = ctx.getState().entries.concat(action.entries);
        }
        return this.entriesApi.restore({ entryIds: entryIds }).pipe(tap(function () {
            ctx.patchState({
                entries: newEntries,
                selectedEntries: [],
            });
            return ctx.dispatch(new TrashedEntriesRestoreSuccess(restoredEntries));
        }));
    };
    DriveState.prototype.emptyTrash = function (ctx) {
        ctx.dispatch(new ShowLoadingToast(LoadingToastMessages.emptyTrash));
        return this.entriesApi.emptyTrash().pipe(finalize(function () { return ctx.dispatch(new HideLoadingToast()); }), tap(function () {
            ctx.patchState({
                entries: [],
                selectedEntries: [],
            });
            return ctx.dispatch(new UserSpaceUsageChanged());
        }));
    };
    DriveState.prototype.addStar = function (ctx, action) {
        var state = ctx.getState(), ids = action.entries.map(function (entry) { return entry.id; });
        return this.entriesApi.addStar(ids).pipe(tap(function (response) {
            var newEntries = state.entries.map(function (entry) {
                if (ids.indexOf(entry.id) > -1) {
                    if (!entry.tags)
                        entry.tags = [];
                    entry.tags.push(response.tag);
                }
                return entry;
            });
            var selectedEntries = state.selectedEntries.map(function (entry) {
                entry.tags.push(response.tag);
                return entry;
            });
            ctx.patchState({
                entries: newEntries,
                selectedEntries: selectedEntries,
            });
        }));
    };
    DriveState.prototype.removeStar = function (ctx, action) {
        var _this = this;
        var state = ctx.getState(), ids = action.entries.map(function (entry) { return entry.id; });
        return this.entriesApi.removeStar(ids).pipe(tap(function (response) {
            var newEntries = state.entries.map(function (entry) {
                if (ids.indexOf(entry.id) > -1)
                    _this.removeTag(entry, response.tag);
                return entry;
            });
            var selectedEntries = state.selectedEntries
                .map(function (entry) { return _this.removeTag(entry, response.tag); });
            ctx.patchState({
                entries: newEntries,
                selectedEntries: selectedEntries
            });
        }));
    };
    DriveState.prototype.removeSelectedEntries = function (ctx, action) {
        var ids = action.entries.map(function (entry) { return entry.id; });
        var newEntries = ctx.getState().entries
            .filter(function (entry) { return ids.indexOf(entry.id) === -1; });
        ctx.patchState({
            entries: newEntries
        });
    };
    DriveState.prototype.copySelectedEntries = function (ctx) {
        var entries = this.store.selectSnapshot(DriveState_1.selectedEntries), entryIds = entries.map(function (entry) { return entry.id; }), folders = entries.filter(function (entry) { return entry.type === 'folder'; }), oldState = ctx.getState();
        ctx.dispatch(new ShowLoadingToast(LoadingToastMessages.copyEntries));
        return this.entriesApi.copy({ entryIds: entryIds }).pipe(finalize(function () { return ctx.dispatch(new HideLoadingToast()); }), tap(function (response) {
            var newState = {};
            // show copied entries, if we are in a folder view
            if (ctx.getState().activePage.folder) {
                newState.entries = oldState.entries.concat(response.entries);
            }
            // rebuild folder tree
            if (folders.length) {
                newState.flatFolders = __assign({}, oldState.flatFolders);
                response.entries
                    .filter(function (folder) { return folder.type === 'folder'; })
                    .forEach(function (folder) { return newState.flatFolders[folder.id] = folder; });
            }
            ctx.patchState(newState);
            // update user space usage
            ctx.dispatch(new UserSpaceUsageChanged());
            // rebuild folder tree
            if (folders.length)
                ctx.dispatch(new BuildFolderTree());
        }));
    };
    DriveState.prototype.openUploadWindow = function (ctx, action) {
        var config = __assign({}, this.uploadInputConfig, { directory: action.type === 'directory' });
        openUploadWindow(config).then(function (files) {
            if (!files || !files.length)
                return;
            ctx.dispatch(new UploadFiles(files));
        });
    };
    DriveState.prototype.loadUserSpaceUsage = function (ctx) {
        return this.entriesApi.getSpaceUsage().pipe(tap(function (spaceUsage) {
            ctx.patchState({ spaceUsage: { used: spaceUsage.used, available: spaceUsage.available } });
        }));
    };
    DriveState.prototype.updateEntries = function (ctx, action) {
        var mainEntries = ctx.getState().entries.slice(), selectedEntries = ctx.getState().selectedEntries.slice();
        action.entries.forEach(function (updatedEntry) {
            // update main entries
            var mainIndex = mainEntries.findIndex(function (entry) { return updatedEntry.id === entry.id; });
            mainEntries[mainIndex] = __assign({}, mainEntries[mainIndex], updatedEntry);
            // update selected entries
            var selectedIndex = selectedEntries.findIndex(function (entry) { return updatedEntry.id === entry.id; });
            if (selectedIndex > -1) {
                selectedEntries[selectedIndex] = __assign({}, selectedEntries[selectedIndex], updatedEntry);
            }
        });
        ctx.patchState({ entries: mainEntries, selectedEntries: selectedEntries });
    };
    DriveState.prototype.updateEntryDescription = function (ctx, _a) {
        var entry = _a.entry, description = _a.description;
        return this.entriesApi.update(entry.id, { description: description })
            .pipe(tap(function (response) {
            ctx.dispatch(new UpdateEntries([response.fileEntry]));
        }));
    };
    DriveState.prototype.breakpointChanged = function (ctx, action) {
        ctx.patchState({
            isMobile: action.status.isMobile,
            sidebarOpen: !action.status.isMobile,
            detailsVisible: !action.status.isMobile,
        });
    };
    DriveState.prototype.setCurrentUser = function (ctx, action) {
        ctx.patchState({ currentUser: action.user });
    };
    DriveState.prototype.resetState = function (ctx) {
        ctx.setState(__assign({}, DRIVE_STATE_MODEL_DEFAULTS, { viewMode: ctx.getState().viewMode }));
    };
    DriveState.prototype.transformQueryParams = function (params) {
        var page = this.store.selectSnapshot(DriveState_1.activePage), meta = this.store.selectSnapshot(DriveState_1.meta);
        var queryParams = __assign({ orderBy: meta.sortColumn, orderDir: meta.sortDirection }, params);
        if (page.folderHash)
            queryParams.folderId = page.folderHash;
        if (meta.query)
            queryParams.query = meta.query;
        if (meta.type)
            queryParams.type = meta.type;
        return queryParams;
    };
    /**
     * Check if user has enough space left to upload all specified files.
     */
    DriveState.prototype.enoughSpaceLeftToUpload = function (spaceUsage, files) {
        var newSize = files.reduce(function (sum, file) { return sum + file.size; }, 0), currentlyUsing = spaceUsage.used, availableSpace = spaceUsage.available;
        return (newSize + currentlyUsing) < availableSpace;
    };
    DriveState.prototype.removeTag = function (entry, tag) {
        entry.tags = entry.tags.filter(function (t) { return t.id !== tag.id; });
        return entry;
    };
    DriveState.canMoveEntriesTo = function (movingEntries, folder) {
        if (!folder)
            return false;
        // should not be able to move folder into it's
        // own child or same folder it's already in
        return movingEntries.every(function (entry) {
            // trying to move file to root, but file is already in root
            if (folder.id === 'root' && entry.parent_id === null)
                return false;
            // entry is already in this folder
            if (folder.id === entry.parent_id)
                return false;
            // trying to move folder into it's own child
            if (folder.path.startsWith(entry.path))
                return false;
            return true;
        });
    };
    var DriveState_1;
    __decorate([
        Action(LoadUserFolders),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "loadUserFolders", null);
    __decorate([
        Action(BuildFolderTree),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, BuildFolderTree]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "buildFolderTree", null);
    __decorate([
        Action(FolderPageOpened),
        Action(RecentEntriesPageOpened),
        Action(TrashPageOpened),
        Action(StarredPageOpened),
        Action(SearchPageOpened),
        Action(SharesFolderOpened),
        Action(ReloadPageEntries),
        Action(LoadMoreEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "loadDriveEntries", null);
    __decorate([
        Action(OpenFolder, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, OpenFolder]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "openFolder", null);
    __decorate([
        Action(OpenSearchPage, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, OpenSearchPage]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "openSearchPage", null);
    __decorate([
        Action(EntriesSelectedViaDrag),
        Action(EntrySelectedViaContextMenu),
        Action(SelectEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "selectEntries", null);
    __decorate([
        Action(DeselectAllEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "deselectAllEntries", null);
    __decorate([
        Action(SelectAllEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "SelectAllEntries", null);
    __decorate([
        Action(EntryTapped),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, EntryTapped]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "entryTapped", null);
    __decorate([
        Action(EntryDoubleTapped),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, EntryDoubleTapped]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "entryDoubleTapped", null);
    __decorate([
        Action(DeleteSelectedEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "deleteSelectedEntries", null);
    __decorate([
        Action(EntryContextMenuOpened),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, EntryContextMenuOpened]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "fileContextMenuOpened", null);
    __decorate([
        Action(NewFolderCreated),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, NewFolderCreated]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "newFolderCreated", null);
    __decorate([
        Action(EntryRenamed),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, EntryRenamed]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "entryRenamed", null);
    __decorate([
        Action(StartedDragging),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "startedDragging", null);
    __decorate([
        Action(StoppedDragging),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "stoppedDragging", null);
    __decorate([
        Action(MoveEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, MoveEntries]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "movieEntries", null);
    __decorate([
        Action(MoveEntriesSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, MoveEntriesSuccess]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "moveEntriesSuccess", null);
    __decorate([
        Action(SetViewMode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetViewMode]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "toggleViewMode", null);
    __decorate([
        Action(ToggleDetailsSidebar),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "toggleDetailsSidebar", null);
    __decorate([
        Action(ToggleSidebar),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "toggleSidebar", null);
    __decorate([
        Action(AddEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, AddEntries]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "addEntries", null);
    __decorate([
        Action(UploadFiles),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UploadFiles]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "uploadFiles", null);
    __decorate([
        Action(DeleteTrashedEntriesForever),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "deleteTrashedEntriesForever", null);
    __decorate([
        Action(RestoreTrashedEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RestoreTrashedEntries]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "restoreTrashedEntries", null);
    __decorate([
        Action(EmptyTrash, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "emptyTrash", null);
    __decorate([
        Action(AddStar, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, AddStar]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "addStar", null);
    __decorate([
        Action(RemoveStar, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RemoveStar]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "removeStar", null);
    __decorate([
        Action(RemoveEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RemoveEntries]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "removeSelectedEntries", null);
    __decorate([
        Action(CopySelectedEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "copySelectedEntries", null);
    __decorate([
        Action(OpenUploadWindow),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, OpenUploadWindow]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "openUploadWindow", null);
    __decorate([
        Action(LoadUserSpaceUsage),
        Action(UserSpaceUsageChanged),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "loadUserSpaceUsage", null);
    __decorate([
        Action(UpdateEntries),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateEntries]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "updateEntries", null);
    __decorate([
        Action(UpdateEntryDescription),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateEntryDescription]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "updateEntryDescription", null);
    __decorate([
        Action(BreakpointChanged),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, BreakpointChanged]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "breakpointChanged", null);
    __decorate([
        Action(SetCurrentUser),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetCurrentUser]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "setCurrentUser", null);
    __decorate([
        Action(ResetState),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState.prototype, "resetState", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "flatFolders", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "userFoldersLoaded", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "activePage", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "activePageName", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "userFolders", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "selectedEntries", null);
    __decorate([
        Selector([DriveState_1.selectedEntries]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array]),
        __metadata("design:returntype", void 0)
    ], DriveState, "selectedEntryIds", null);
    __decorate([
        Selector([DriveState_1.selectedEntries]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array]),
        __metadata("design:returntype", void 0)
    ], DriveState, "selectedEntry", null);
    __decorate([
        Selector([DriveState_1.selectedEntry]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array]),
        __metadata("design:returntype", void 0)
    ], DriveState, "selectedEntryOrActiveFolder", null);
    __decorate([
        Selector([DriveState_1.selectedEntryOrActiveFolder, DriveState_1.flatFolders]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "selectedEntryParent", null);
    __decorate([
        Selector([DriveState_1.selectedEntries]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array]),
        __metadata("design:returntype", void 0)
    ], DriveState, "anythingSelected", null);
    __decorate([
        Selector([DriveState_1.selectedEntries]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array]),
        __metadata("design:returntype", void 0)
    ], DriveState, "allSelectedEntriesStarred", null);
    __decorate([
        Selector([DriveState_1.selectedEntries]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array]),
        __metadata("design:returntype", void 0)
    ], DriveState, "onlyFoldersSelected", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "entries", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "entriesEmpty", null);
    __decorate([
        Selector([DriveState_1.selectedEntries]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array]),
        __metadata("design:returntype", void 0)
    ], DriveState, "multipleEntriesSelected", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "activeFolder", null);
    __decorate([
        Selector([DriveState_1.selectedEntries]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array]),
        __metadata("design:returntype", void 0)
    ], DriveState, "selectedFolderId", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "meta", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "dragging", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "loading", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "currentPage", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "viewMode", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "detailsOpen", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "sidebarOpen", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "sortColumn", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "sortDirection", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "canLoadMoreEntries", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "userSpaceUsed", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "userSpaceAvailable", null);
    __decorate([
        Selector([DriveState_1.userSpaceUsed, DriveState_1.userSpaceAvailable]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Number, Number]),
        __metadata("design:returntype", void 0)
    ], DriveState, "spaceUsedPercent", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "isMobile", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DriveState, "currentUser", null);
    __decorate([
        Selector([DriveState_1.activeFolder, DriveState_1.currentUser]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, User]),
        __metadata("design:returntype", void 0)
    ], DriveState, "userOwnsActiveFolder", null);
    __decorate([
        Selector([DriveState_1.activeFolder, DriveState_1.currentUser]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, User]),
        __metadata("design:returntype", void 0)
    ], DriveState, "userCanEditSelectedFolder", null);
    __decorate([
        Selector([DriveState_1.selectedEntries, DriveState_1.currentUser]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array, User]),
        __metadata("design:returntype", void 0)
    ], DriveState, "userCanEditSelectedEntries", null);
    __decorate([
        Selector([DriveState_1.activePage, DriveState_1.userCanEditSelectedFolder]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DrivePage, Boolean]),
        __metadata("design:returntype", void 0)
    ], DriveState, "canUpload", null);
    DriveState = DriveState_1 = __decorate([
        State({
            name: 'drive',
            defaults: DRIVE_STATE_MODEL_DEFAULTS,
        }),
        __metadata("design:paramtypes", [FoldersApiService,
            DriveEntryApiService,
            Router,
            DriveUrlsService,
            UploadQueueService,
            Store,
            LocalStorage,
            DriveUploadValidator, Object])
    ], DriveState);
    return DriveState;
}());
export { DriveState };
